import DOMPurify from 'dompurify';
import draftToHtml from 'draftjs-to-html';
import Linkify from 'linkify-react';
import parse from 'html-react-parser';

// User-provided post bodies pass through draftToHtml which can emit any
// element/attribute the Draft.js entityMap encodes — including raw <script>
// or onerror handlers. Sanitize before parse so the resulting React tree
// only contains safe HTML.
const sanitize = (html: string): string =>
  DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });

const convert = (rawJsonFormat: string) => {
  try {
    const parsed = JSON.parse(rawJsonFormat);
    const safeHtml = sanitize(draftToHtml(parsed));
    return (
      <Linkify
        options={{
          target: '_blank',
          className: ' text-sky hover:text-sky-light break-all',
        }}
      >
        {parse(safeHtml)}
      </Linkify>
    );
  } catch (error) {
    // Fallback when rawJsonFormat isn't valid Draft.js JSON. Render as plain
    // text — React escapes string children automatically, no HTML parsing
    // needed and no XSS surface.
    return <p>{rawJsonFormat}</p>;
  }
};

export default convert;
